var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fullScrennVisiable)?_c('div',{staticClass:"rnui-layer",class:{
			'rnui-layer-active': _vm.fullScrennVisiable,
			animate__zoomIn: _vm.fullScrennVisiable,
		}},[_c('svg',{staticClass:"icon close",attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClose}},[_c('use',{attrs:{"xlink:href":`#icon-sohu-guanbi`}})]),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }